import { cr } from "fire-wind-water";
import { rs } from "../../sbase";

function getLangSuffix() {
  try {
    var lang = window.localStorage.getItem("current_i18n") || "zh_CN";
    if (lang === "en_US") return "_en";
    if (lang === "zh_TW") return "_tw";
  } catch (e) {
    /* ignore */
  }
  return "";
}

function mergeI18nValue(base, langVal) {
  if (!langVal || typeof langVal !== "object" || typeof base !== "object") {
    return base;
  }
  var merged = {};
  var baseKey;
  for (baseKey in base) {
    if (Object.prototype.hasOwnProperty.call(base, baseKey)) {
      merged[baseKey] = base[baseKey];
    }
  }
  var langKey;
  for (langKey in langVal) {
    if (
      Object.prototype.hasOwnProperty.call(langVal, langKey) &&
      langKey !== "display"
    ) {
      merged[langKey] = langVal[langKey];
    }
  }
  return merged;
}

export function $extras(arr) {
  var suffix = getLangSuffix();
  var json = {
    extras: {},
    groups: {},
  };
  cr.each(arr, function (m) {
    json[m.usePage] = {};
    cr.each(m.extra, function (d) {
      json.extras[d.key] = d.value;
      json.groups[d.key] = d.value;
      json[m.usePage][d.key] = d.value;
      cr.each(d.items, function (o) {
        if (cr.isArray(o.asHideModule)) {
          if (
            o.asHideModule.indexOf(rs.moduleId) !== -1 ||
            o.asHideModule.indexOf(parseInt(rs.moduleId)) !== -1
          ) {
            return;
          }
        }
        json.extras[o.key] = o.value;
        json[m.usePage][o.key] = o.value;
      });
      // 模式1：group 内兄弟 item 覆盖
      if (suffix && d.items) {
        cr.each(d.items, function (o) {
          var langKey = o.key + suffix;
          var langItem = null;
          cr.each(d.items, function (s) {
            if (s.key === langKey) langItem = s;
          });
          if (langItem && langItem.value) {
            json.extras[o.key] = mergeI18nValue(o.value, langItem.value);
            if (json[m.usePage]) {
              json[m.usePage][o.key] = json.extras[o.key];
            }
          }
        });
      }
    });
  });
  // 模式2：扁平 key 覆盖 + 模式3：value 对象内部字段覆盖
  if (suffix) {
    var extrasKey;
    for (extrasKey in json.extras) {
      if (!Object.prototype.hasOwnProperty.call(json.extras, extrasKey)) {
        continue;
      }
      // 模式2：扁平 key（如 signUpText_en 覆盖 signUpText）
      if (
        extrasKey.length > suffix.length &&
        extrasKey.indexOf(suffix, extrasKey.length - suffix.length) !== -1
      ) {
        var baseKey = extrasKey.substring(0, extrasKey.length - suffix.length);
        if (json.extras[baseKey] && json.extras[extrasKey]) {
          json.extras[baseKey] = mergeI18nValue(
            json.extras[baseKey],
            json.extras[extrasKey]
          );
        }
      }
      // 模式3：value 对象内部字段（如 formTitle.title_en 覆盖 formTitle.title）
      var val = json.extras[extrasKey];
      if (!val || typeof val !== "object") continue;
      var field;
      for (field in val) {
        if (!Object.prototype.hasOwnProperty.call(val, field)) continue;
        if (
          field.length > suffix.length &&
          field.indexOf(suffix, field.length - suffix.length) !== -1
        ) {
          var baseField = field.substring(0, field.length - suffix.length);
          if (val[baseField] !== undefined) {
            val[baseField] = val[field];
          }
        }
      }
    }
  }
  return json;
}

export function $extraItem(value, str, defaultVal) {
  if (value && str) {
    const arr = str.split(".");
    let v = null;
    let m = value;
    for (let i = 0; i < arr.length; i++) {
      v = m[arr[i]];
      if (v) {
        m = v;
      } else {
        if (v === undefined && defaultVal) {
          m = defaultVal;
        } else {
          m = "";
        }
        break;
      }
    }
    return m;
  }
  return value;
}
